import styled, { css } from "styled-components";

export const AudioPlayerContainer = styled.div`
  --icon-color: rgb(91 91 91 / 95%);
  --button-bg: var(--gradient-navy-blue-primary);
  --progress-bar-bg: #e2e2e2;
  --thumb-size: 17px;
  --increase-touch-area: 10px;
  --bar-height: 3px;
  --bar-easing: 0.2s ease-in-out;
  --input-border-radius: 5px;

  ${({ $isError }) =>
    $isError &&
    css`
      &:after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0px;
        left: 0px;
        background-color: white;
        opacity: 0.5;
        z-index: 1000;
      }
    `}

  width: 100%;
  height: 55px;
  position: relative;
  background: var(--button-bg);
  border: 1px solid white;
  border-radius: 10px;

  display: grid;
  grid-template-columns: 36px 1fr 65px;
  justify-items: center;
  align-items: center;
  gap: 12px;
  padding-inline: 8px;

  div.button-action-item {
    display: grid;
    align-content: center;

    button.action {
      position: relative;
      width: 30px;
      height: 30px;
      border: none;
      border-radius: 50%;
      background: #f5f5f5;
      outline: 1px solid #ffffff3d;
      outline-offset: 2px;

      &.playing:before,
      &.playing:after {
        content: "";
        position: absolute;
        width: 2px;
        height: 9px;
        background-color: var(--icon-color);
        top: 50%;
        transform: translateY(-50%);
      }
      &:before {
        left: 39%;
      }
      &:after {
        right: 39%;
      }
      &.pausing:after {
        content: "";
        position: absolute;
        top: 31%;
        left: 40%;
        border-style: solid;
        border-width: 6px 0 6px 10px;
        border-color: transparent transparent transparent var(--icon-color);
      }
    }
  }

  div.seek-control {
    width: 100%;
    display: flex;
    position: relative;

    &:before {
      content: "";
      width: 100%;
      height: var(--bar-height);
      background-color: var(--progress-bar-bg);
      position: absolute;
      top: 0px;
      left: 0px;
      border-radius: var(--input-border-radius);
    }

    input[type="range"] {
      width: 100%;
      height: var(--bar-height);
      background-color: var(--progress-bar-bg);
      background: linear-gradient(to right, var(--ktb-blue-main) 100%, var(--progress-bar-bg) 100%);
      transition: background-size 0.1s linear;
      background-size: ${({ $ignoreProgress }) => (!$ignoreProgress ? "var(--percent)" : "0%")} 100%;
      background-repeat: no-repeat;
      border-radius: var(--input-border-radius);
      -webkit-appearance: none;
      appearance: none;
      z-index: 1;

      &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: var(--thumb-size);
        height: var(--thumb-size);
        border: none;
        border-radius: 50%;
        background: white;
      }

      &::-moz-range-thumb {
        width: var(--thumb-size);
        height: var(--thumb-size);
        border: none;
        border-radius: 50%;
        background: white;
      }

      &::-ms-thumb {
        width: var(--thumb-size);
        height: var(--thumb-size);
        border: none;
        border-radius: 50%;
        background: white;
      }
    }
  }

  .remain-duration {
    color: #d7d5d5;
  }
`;
